@if (!isInStandaloneMode) {
  <div>
    <!-- Android: Hiển thị nút "Install App" -->
    @if (showInstallButton) {
      <button
        class="btn btn-add-homescreen w-100 text-uppercase fw-bold d-flex align-items-center justify-content-center"
        (click)="addToHomeScreen()"
      >
        <ng-icon
          class="me-2"
          name="matAddBoxOutline"
        ></ng-icon>
        {{ 'UI.Common.AddHomescreen' | translate }}
      </button>
    }
  </div>
}
